import React from 'react';
import { BsCameraVideo } from '@react-icons/all-files/bs/BsCameraVideo';

import { decorateComponent } from '../../documentComponents';
import { Video } from './Video';
import { VideoInspector } from './Video.Inspector';

export default decorateComponent(Video, 'block', {
  id: 'video',
  label: '비디오',
  defaultProps: {
    loop: false,
    muted: true,
    autoplay: true,
  },
  allowedChildren: [],
  disallowedAncestors: [
    'a',
    'coupon',
    'tabButton',
  ],
  renderIcon: () => <BsCameraVideo />,
  renderInspector: VideoInspector,
});
